module.exports = __webpack_public_path__ + "files/nvdm.98a63188c9af649403416a98eb2d5dce.pdf";